<template>
  <b-table
    :items="items"
    :fields="fields.filter((each) => each.selected)"
    :hover="true"
    :sort-by.sync="sortBy"
    :sort-desc.sync="sortDesc"
    :per-page="0"
    :current-page="currentPage"
    @row-selected="onRowSelected"
    select-mode="single"
    selectable
    show-empty
    label-sort-asc=""
    label-sort-desc=""
    label-sort-clear=""
    sort-icon-right
    :no-border-collapse="true"
    responsive="lg"
    :thead-class="`table-thead text-center bg-transparent ${theadClass}`"
    :tbody-class="`table-tbody text-center ${tbodyClass}`"
    ref="selectableTable"
    info="true"
    class="new-theme-custom-table"
  >
    <template #empty> {{ $t("empty-row") }} </template>
    <template #head(id)="data">
      <span v-if="data">#</span>
    </template>

    <template #cell(source)="{ item }">
      <div class="d-flex justify-content-evenly">
        <div v-if="item.img">
          <img :src="require(`@/assets/images/${item.img}.svg`)" />
        </div>
        <div>{{ item.source }}</div>
      </div>
    </template>

    <template #head(actions)="data">
      <span v-if="data"></span>
    </template>

    <template #cell(paymentMethod)="{ item }">
      <div class="d-flex justify-content-evenly">
        <div>{{ item?.paymentMethod ? $t(item?.paymentMethod?.toLowerCase()) : "---" }}</div>
      </div>
    </template>

    <template #cell(actions)="{ item }">
      <div class="d-flex fit-content">
        <b-dropdown v-if="!disabledEdit" variant="transparent">
          <div
            class="d-flex flex-column justify-content-center delete-edit-model"
          >
            <div
              id="clients_edit"
              v-if="!disabledEdit"
              class="d-flex justify-content-center delete-edit-model-text"
              @mouseenter="EditHovered = true"
              @mouseleave="EditHovered = false"
              @click.stop="moveToEdit(item.clientId)"
            >
              <img
                :src="
                  EditHovered
                    ? require('@/assets/images/icons/pincle-edit.svg')
                    : require('@/assets/images/icons/pincle-edit.svg')
                "
                width="13"
                alt="edit"
              />
              <p class="text-center my-2 mx-3">{{ $t("edit") }}</p>
            </div>
            <hr class="my-0" />
          </div>
        </b-dropdown>
      </div>
    </template>
  </b-table>
</template>

<script>
export default {
  props: [
    "tbodyClass",
    "theadClass",
    "items",
    "fields",
    "currentPage",
    "sortByProp",
    "sortDescProp",
  ],
  emits: ["changeParentSorting"],
  data() {
    return { EditHovered: false, sortBy: "", sortDesc: false };
  },
  methods: {
    onRowSelected(items) {
      if (!this.$store.getters["enums/is_not_permitted"]("editClient"))
        this.$router.push(`/client/${items[0].clientId}`).catch(() => {});
    },
    moveToEdit(clientId) {
      if (!this.$store.getters["enums/is_not_permitted"]("editClient"))
        this.$router.push(`/client/edit/${clientId}`).catch(() => {});
    },
  },
  computed: {
    disabledEdit() {
      return this.$store.getters["enums/is_not_permitted"]("editClient");
    },
    disabledDelete() {
      return this.$store.getters["enums/is_not_permitted"]("deleteClient");
    },
  },
  watch: {
    sortBy(val) {
      this.$emit("changeParentSorting", val, this.sortDesc);
    },
    sortDesc(val) {
      this.$emit("changeParentSorting", this.sortBy, val);
    },
    sortByProp(val) {
      this.sortBy = val;
    },
    sortDescProp(val) {
      this.sortDesc = val;
    },
  },
};
</script>
